import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appExternalLink]',
})
export class ExternalLinkConfirmDirective {

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Find closest anchor tag
    const anchor = target.closest('a') as HTMLAnchorElement;
    if (!anchor || !anchor.href) return;

    const isExternal = !anchor.href.includes(window.location.hostname);

    if (isExternal) {
      event.preventDefault();

      const confirmed = window.confirm('Möchtest du den externen Link öffnen?');

      if (confirmed) {
        window.open(anchor.href, '_blank');
      }
    }
  }
}